import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const SubjectDetail = () => {
  const [subjectDetails, setSubjectDetails] = useState([]);
  const { subjectName } = useParams();

  useEffect(() => {
    fetchSubjects();
  }, []);

  const fetchSubjects = async () => {
    try {
      const response = await fetch('https://wsmsv1.aidigitalsec.com/api/TeacherDashboard/Dashboard_SubjectCard', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
      });
      const data = await response.json();
      setSubjectDetails(data.list);
    } catch (error) {
      console.error('Error fetching subjects:', error);
    }
  };

  return (
    <div style={{
      padding: '32px',
      maxWidth: '900px',
      marginTop: '40px',
      margin: '0 auto',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    }}>
      <h1 style={{
        textAlign: 'center',
        color: '#1976d2',
        marginBottom: '32px',
        fontWeight: 500,
      }}>
        Subject Details for {subjectName}
      </h1>

      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        borderRadius: '8px',
        overflow: 'hidden',
        backgroundColor: '#fff',
      }}>
        <thead>
          <tr style={{ backgroundColor: '#1976d2' }}>
            <th style={{
              padding: '16px',
              textAlign: 'left',
              color: '#fff',
              fontWeight: 600,
              fontSize: '16px',
            }}>Class</th>
            <th style={{
              padding: '16px',
              textAlign: 'left',
              color: '#fff',
              fontWeight: 600,
              fontSize: '16px',
            }}>Section</th>
            <th style={{
              padding: '16px',
              textAlign: 'left',
              color: '#fff',
              fontWeight: 600,
              fontSize: '16px',
            }}>Subject</th>
          </tr>
        </thead>
        <tbody>
          {subjectDetails.map((detail, index) => (
            <tr 
              key={index}
              style={{
                backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#fff',
                transition: 'background-color 0.2s',
                ':hover': { backgroundColor: '#e3f2fd' }, // Note: true hover needs CSS or separate handling
              }}
            >
              <td style={{
                padding: '14px 16px',
                borderBottom: '1px solid #eee',
              }}>{detail.className}</td>
              <td style={{
                padding: '14px 16px',
                borderBottom: '1px solid #eee',
              }}>{detail.secrionName}</td>
              <td style={{
                padding: '14px 16px',
                borderBottom: '1px solid #eee',
              }}>{detail.subjectName}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SubjectDetail;